import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import { ApiClient, ApiUtils } from "@yodlee/common-components/dist/utilities";
import amplitude from "amplitude-js";
import qs from "qs";
import { UrlConfigs } from "../configurations";
/*===========UnComment for Mock ========== */
// import * as AmplitudeMock from "../mocks/amplitude";
/*================================ */
import { IPreferences } from "../types/interfaces";
import { Onload } from "../types/interfaces/onload";
import ssoFormData from "../types/interfaces/sso-formdata";
import { GenerateOtp } from "../types/interfaces/otp";

/*===========UnComment for Mock ========== */
// AmplitudeMock.startMock(Axios);
/*================================ */

export const onload = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = false) => new Promise<Onload>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.ONLOAD}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            amplitude.init(response.data.amplitudeId, response.data.user.userName, {
                includeReferrer: true
            }, () => {
                amplitude.getInstance().setUserProperties({
                    cobrand: { id: response.data.financialInstitution.id, name: response.data.financialInstitution.name },
                    user: response.data.user,
                });
                resolve(response.data);
            });
        }).catch((error) => {
            reject(error);
        });
    })
})

export const logo = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.LOGO}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
            responseType: "blob"
        }).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const configToolToken = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.AUTH_TOKEN}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response?.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const permission = (authentication: Authentication) => ({
    get: (userId: number, filters?: any, isBrandSpecific = false) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.USER_PERMISSION(userId)}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const insightsUsers = (authentication: Authentication) => ({
    get: () => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.INSIGHT_USERS}`, {
            withCredentials: true,
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const userFeatures = (authentication: Authentication) => ({
    get: (userId: number, filters?: any, isBrandSpecific = false) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.USER_FEATURES(userId)}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const banner = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.BANNER}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
            responseType: "blob"
        }).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const keepAlive = (authentication: Authentication) => ({
    get: () => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.KEEP_ALIVE}`, {
            withCredentials: true,
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    })
})

export const picture = (authentication: Authentication) => ({
    get: (userId: number, filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.PICTURE(userId)}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
            responseType: "blob"
        }).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const preference = (authentication: Authentication) => ({
    get: () => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.PREFERENCE}`, {
            withCredentials: true,
            params: {
                appId: process.env.REACT_APP_APPLICATION_ID || 'orbit'
            },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }, true).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        })
    }),
    put: (preference: IPreferences.Preferences) => new Promise<any>((resolve, reject) => {
        ApiClient.put(`${UrlConfigs.API_URLS.PREFERENCE}`, { preference: JSON.stringify(preference || {}) }, {
            withCredentials: true,
            params: {
                appId: process.env.REACT_APP_APPLICATION_ID || 'orbit'
            },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }, true).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        })
    }),
})

export const onDataCenterChange = (authentication: Authentication) => ({
    get: (filters?: any) => new Promise<ssoFormData>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.SSO_INFO_URL}`, {
            withCredentials: true,
            params: { ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    })
})

export const consolidatedKeepAlive = (keepAliveUrl: string) => ({
    get: () => new Promise<any>((resolve, reject) => {
        ApiClient.get(keepAliveUrl, {
            withCredentials: true
        }).catch((error) => {
            reject(error);
        });
    })
})

export const openBankingStatus = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.OPEN_BANKING_STATUS}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    })
})

export const helpContentAuthToken = (authentication: Authentication) => ({
    get: () => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.AUTH_TOKEN}`, {
            withCredentials: true,
            params: { view: "HELP_TEXT_TOKEN" },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const refreshCachedData = (authentication: Authentication) => ({
    get: (filters?: any) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.REFRESH_CACHED_DATA}`, {
            withCredentials: true,
            params: { ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const caWebformInit = () => ({
    get: (filters?: any) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.CA_WEBFORM_INIT}`, {
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const brandProducts = (authentication: Authentication) => ({
    get: (filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.BRAND_PRODUCTS}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const unsubscribeNotification = () => ({
    generateOtp: (email: string) => new Promise<GenerateOtp>((resolve, reject) => {
        ApiClient.post(`${UrlConfigs.API_URLS.UNSUBSCRIBE_NOTIFICATION_GENERATE}`, { email: email }, {
            withCredentials: false,
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    }),
    verifyOtp: (values: any) => new Promise<any>((resolve, reject) => {
        ApiClient.post(`${UrlConfigs.API_URLS.UNSUBSCRIBE_NOTIFICATION_VERIFY}`, values, {
            withCredentials: false,
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})

export const tag = (authentication: Authentication) => ({
    getAll: (filters?: any, isBrandSpecific = true) => new Promise<Array<any>>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.TAG}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data.data || response.data);
        }).catch((error) => {
            reject(error);
        })
    }),
    get: (tagId: number, filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.get(`${UrlConfigs.API_URLS.TAG}/${tagId}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    }),
    create: (tag: any, filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.post(`${UrlConfigs.API_URLS.TAG}`, tag, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    }),
    update: (tagId: number, tag: any, filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.put(`${UrlConfigs.API_URLS.TAG}/${tagId}`, tag, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    }),
    delete: (tagId: number, filters?: any, isBrandSpecific = true) => new Promise<any>((resolve, reject) => {
        ApiClient.delete(`${UrlConfigs.API_URLS.TAG}/${tagId}`, {
            withCredentials: true,
            params: { ...isBrandSpecific && { brandId: authentication.selectedBrand.id }, ...filters },
            headers: ApiUtils.getAuthorizationHeader(authentication)
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
})